import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GearFill, PersonFill, BugFill, BoxArrowRight, ArrowLeft, TicketPerforatedFill } from "react-bootstrap-icons";

import Layout from 'components/Layout/Layout';

import Account from "./help/Account";
import Debug from "./help/Debug";
import General from "./help/General";
import Invites from "./help/Invites";

import { useLocalStorage } from 'utils/storage';
import axiosInstance from "utils/axiosInstance";

import { fetchUserData, setUserData } from "services/auth";

import packageJson from "../../../package.json";

import "./styles.css";

const Settings = () => {
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
	const [showContent, setShowContent] = useState(false);
	const [user, setUser] = useLocalStorage('user', null);

	const settingsSections = [
        { id: "account", name: "Account", icon: <PersonFill size={20} /> },
		{ id: "general", name: "General", icon: <GearFill size={20} /> },
		{ id: "invites", name: "Invites", icon: <TicketPerforatedFill size={20} /> },
		{ id: "debug", name: "Debug", icon: <BugFill size={20} /> },
    ];
	const [activeSection, setActiveSection] = useState(isMobile ? null : "account");

	const navigate = useNavigate();
	const handleLogout = async () => {
		try {
			await axiosInstance.post(`/api/auth/logout`);

			localStorage.clear();
			sessionStorage.clear();
			delete axiosInstance.defaults.headers.common['Authorization'];

			navigate('/login');
		} catch (error) {
			localStorage.clear();
			sessionStorage.clear();
			delete axiosInstance.defaults.headers.common['Authorization'];

			navigate('/login');
		}
	};

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth < 768);
			if (window.innerWidth >= 768) setShowContent(false);
		};

		const getUserData = async () => {
			try {
				const userData = await fetchUserData();
				setUserData(userData);
			} catch (error) {
				console.error("Failed to fetch user data:", error);
			}
		};

		getUserData();

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

    const renderContent = () => {
        switch (activeSection) {
            case "account":
                return <Account />;
            case "general":
                return <General />;
			case "debug":
				return <Debug />;
			case "invites":
				return <Invites />;
            default:
                return null;
        }
    };


	return (
		<Layout title="Settings">
			<div className="row">

				{/* Sidebar */}
				{!isMobile || !showContent ? (
				<div className="col-md-4">
					<div className="card container-height left-navigation">
						<div className="card-header border-bottom no-background">
							<div className="text-center p-2">
								<h6 className="mb-0">{user?.name || 'Loading...'}</h6>
								<small className="text-muted">{user?.email || 'Loading...'}</small>
							</div>
						</div>

						<div className="card-body d-flex flex-column px-0 pb-1">
							<div className="d-flex flex-column">
								<ul className="list-unstyled flex-grow-1">
									{settingsSections.map((section) => (
										<li
											key={section.id}
											className={`d-flex align-items-center p-2 rounded cursor-pointer ${activeSection === section.id ? "bg-primary text-white" : "themed-text"
												}`}
											onClick={() => {
												setActiveSection(section.id);
												setShowContent(true);
											}}
											style={{ cursor: "pointer" }}
										>
											<span className="me-2">{section.icon}</span> {section.name}
										</li>
									))}
								</ul>
							</div>

							<div className="mt-auto text-muted">
								Version: {packageJson.version}
							</div>
		
						</div>

						<div className="card-footer text-center border-top form-card-footer-paddings no-background">
							<button
								className="btn btn-danger w-100"
								onClick={handleLogout}
							>
								<BoxArrowRight className="me-2" />
								Logout
							</button>
						</div>

					</div>
					</div>
				) : null}


				{/* Main Content */}
				{(!isMobile || showContent) && (
					<div className="col-md-8">
						<div className="card container-height">

							<div className="card-header form-card-header-paddings no-background no-border">
								<div className="p-2">
									<h3>{settingsSections.find((s) => s.id === activeSection)?.name}</h3>
								</div>
							</div>

							<div className="card-body form-card-body-paddings overflow-auto">
								{renderContent()}
							</div>

							{isMobile && (
								<div className="card-footer form-card-footer-paddings border-top no-background">
									<div className="d-flex justify-content-between">
										<button
											type="button"
											className="btn btn-secondary ms-auto"
											onClick={(e) => {
												e.preventDefault();
					
												setShowContent(false);
											}}
										>
											<ArrowLeft className="me-2" />
											Back
										</button>
									</div>
								</div>
							)}
						</div>
					</div>
				)}
			</div>
		</Layout>
    );

};

export default Settings;
